module.exports = __webpack_public_path__ + "media/images/partners/google-ea0a0ad9455ce0ea17ff60a07f57c681.svg";